export default function PHP_is_resource() {
  return (
    <div>
      <h1>PHP_is_resource</h1>
    </div>
  );
}
